import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initSentry } from "./lib/sentry";

// Init error tracking before mounting React so the global error/unhandled-
// rejection listeners are installed immediately. No-op when VITE_SENTRY_DSN
// is unset.
initSentry();

// Test trigger for verifying client-side error tracking end-to-end
// (Task #405). Visit any page with `?__sentry_test=1` to throw a synthetic
// error caught by the top-level Sentry ErrorBoundary.
if (typeof window !== "undefined" && window.location.search.includes("__sentry_test=1")) {
  setTimeout(() => {
    throw new Error("Sentry test error from web app");
  }, 0);
}

(() => {
  try {
    const stored = window.localStorage.getItem("zindeal-theme");
    const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
    const theme = stored === "dark" || stored === "light"
      ? stored
      : prefersDark ? "dark" : "light";
    if (theme === "dark") document.documentElement.classList.add("dark");
    document.documentElement.style.colorScheme = theme;
  } catch {
    // ignore
  }
})();

createRoot(document.getElementById("root")!).render(<App />);
